import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextInput from "../Common/TextInput";
import CustomButton from "../Common/CustomButton";
import { theme } from "../../Assets/Theme/theme";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../Assets/Constants";

function LoginFrom() {
  const [inputValues, setInputValues] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState([])
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredForgot, setIsHoveredForgot] = useState(false);
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();

  const handleChange = (field, value) => {
    setInputValues((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/login`, inputValues, {
        withCredentials: true,
      });
      if (response?.data?.token) {
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: 'orange', color: 'white' },
        });

        if (response?.data?.user?.role === "Admin") {
          localStorage.setItem("adminData", JSON.stringify(response?.data))
        } else {
          localStorage.setItem("loginData", JSON.stringify(response?.data));
        }
        navigate(
          response?.data?.user?.role === "Admin"
            ? "/admin/dashboard"
            : "/"
        )
      } else if (response?.data?.error) {
        setErrors(response?.data?.error)
      }
    } catch (error) {      
      if (error?.response?.data?.message) {
        toast.error(`${error?.response?.data?.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error("Login failed. Please check your credentials.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } finally {
      setLoading(false)
    }
  };

  const getErrorMessage = (field) => {
    const fieldError = errors?.find((err) => err?.path === field);
    return fieldError?.msg || null;
  };

  const clearErrorMessage = (field) => {
    setErrors((prevErrors) => prevErrors.filter((err) => err?.path !== field));
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        handleSubmit()
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [inputValues]);

  return (
    <Box
      width={"60%"}
      margin={"0 auto"}
      sx={{
        "@media (max-width:400px)": {
          width: "80%",
        },
      }}
    >
      <Box>
        <TextInput
          label={"Email"}
          placeholder={"Enter Your Email..."}
          type={"email"}
          name={"email"}
          onChange={(e) => {
            handleChange("email", e.target.value)
            clearErrorMessage("email");
          }}
        />
        {getErrorMessage("email") && (
          <Box color="red" mb={2}>
            {getErrorMessage("email")}
          </Box>
        )}
        <TextInput
          label={"Password"}
          placeholder={"Enter Your Password..."}
          type={"password"}
          name={"password"}
          onChange={(e) => {
            handleChange("password", e.target.value)
            clearErrorMessage("password");
          }}
        />
        {getErrorMessage("password") && (
          <Box color="red" mb={2}>
            {getErrorMessage("password")}
          </Box>
        )}
        <CustomButton onClick={handleSubmit}>
          {loading ? <CircularProgress size={30} sx={{ color: "white" }} /> : 'Login'}
        </CustomButton>
      </Box>
      <Box mt={2} onClick={() => navigate('/forgot-password')}>
        <p style={{
          color: theme.colors.orange,
          fontWeight: "600",
          fontSize: 17,
          cursor: "pointer",
          textDecoration: isHoveredForgot ? "underline" : "none",

        }} onMouseEnter={() => setIsHoveredForgot(true)}
          onMouseLeave={() => setIsHoveredForgot(false)}>Forgot Password?</p>
      </Box>
      <Box textAlign={"center"} marginTop={2} color={theme.colors.text}>
        Don't have an account?{" "}
        <span
          style={{
            color: theme.colors.orange,
            fontWeight: "600",
            fontSize: 17,
            cursor: "pointer",
            textDecoration: isHovered ? "underline" : "none",
          }}
          onClick={() => navigate("/register")}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          Sign Up
        </span>
      </Box>
    </Box>
  );
}

export default LoginFrom;
